import { InputNumber } from 'primeng/inputnumber';

/**
 * 2026-09-15 — guard for a PrimeNG 21 InputNumber crash seen live:
 *   SyntaxError: Invalid regular expression: /?/g: Nothing to repeat
 *   at updateInput <- updateValue <- insert <- onInputKeyPress
 *
 * When part of a number field's text is SELECTED, PrimeNG's onInputKeyPress sends ANY typed
 * character to insert() (the digit/decimal/minus check only runs when nothing is selected), and
 * the 'range-insert' branch of updateInput() builds `new RegExp(char)` without escaping it. So
 * typing "?" (Shift + /, e.g. reaching for the Quick Search / shortcuts key), "*", "+", "(" or "["
 * over a selected number threw and left the field in a broken state.
 *
 * Fix: while text is selected, a character that is not a digit, the field's decimal sign or its
 * minus sign is ignored (PrimeNG already calls preventDefault for it, so nothing is typed either
 * way). Every other key press goes through PrimeNG's own handler unchanged. Remove this file once
 * PrimeNG escapes that regex itself.
 */
const proto = InputNumber.prototype as any;
if (proto && typeof proto.onInputKeyPress === 'function' && !proto.__llSelectionGuard) {
  const original = proto.onInputKeyPress;
  proto.onInputKeyPress = function (this: any, event: KeyboardEvent) {
    try {
      const el: HTMLInputElement | undefined = this.input?.nativeElement;
      const code = (event as any).which || event.keyCode;
      if (el && code !== 13 && el.selectionStart !== el.selectionEnd) {
        const char = String.fromCharCode(code);
        const isDigit = code >= 48 && code <= 57;
        const isDecimal = event.code === 'NumpadDecimal' || !!this.isDecimalSign?.(char);
        const isMinus = !!this.isMinusSign?.(char);
        if (!isDigit && !isDecimal && !isMinus) {
          event.preventDefault();
          return;
        }
      }
    } catch {
      // never let the guard itself block typing — fall through to PrimeNG
    }
    return original.call(this, event);
  };
  proto.__llSelectionGuard = true;
}
